import React from 'react'
import CMS from '../../components/cms/CMS'

const CMSInfoPage = () => {
    return (
        <CMS>

        </CMS>
    )
}

export default CMSInfoPage
